import { render, staticRenderFns } from "./records-detail.vue?vue&type=template&id=46f9ba20&scoped=true"
import script from "./records-detail.vue?vue&type=script&lang=js"
export * from "./records-detail.vue?vue&type=script&lang=js"
import style0 from "./records-detail.vue?vue&type=style&index=0&id=46f9ba20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f9ba20",
  null
  
)

export default component.exports